// =============================================================================
// V2 OddsBar — две side-карточки YES/NO с большими процентами и multiplier'ом.
// Заменяет старый прогресс-бар на более expressive V2-стиль.
// =============================================================================

import { yesPercent } from '@/lib/format';

export function OddsBar({
  poolYesMicro,
  poolNoMicro,
  size = 'md',
}: {
  poolYesMicro: number;
  poolNoMicro: number;
  size?: 'sm' | 'md' | 'lg';
}) {
  const yes = yesPercent(poolYesMicro, poolNoMicro);
  const no = 100 - yes;

  // Multiplier rates (1 / share)
  const yesMult = yes > 0 ? (100 / yes).toFixed(2) : '—';
  const noMult = no > 0 ? (100 / no).toFixed(2) : '—';

  const numSize = { sm: 'text-lg', md: 'text-2xl', lg: 'text-5xl' }[size];
  const labelSize = { sm: 'text-[9px]', md: 'text-[10px]', lg: 'text-[11px]' }[size];
  const padding = { sm: 'p-2.5', md: 'p-3', lg: 'p-4' }[size];

  return (
    <div className="grid grid-cols-2 gap-1.5">
      {/* YES (lime) */}
      <div className={`relative overflow-hidden border border-yes bg-yes/10 ${padding}`}>
        <div
          className="absolute inset-y-0 left-0 bg-yes/15 transition-[width] duration-500 ease-out"
          style={{ width: `${yes}%` }}
        />
        <div className="relative flex items-baseline justify-between">
          <span className={`display tracking-[0.1em] text-yes ${labelSize}`}>ДА</span>
          <span className={`display text-yes ${numSize} leading-none`}>{yes}%</span>
        </div>
        <div className="relative mt-1 font-mono text-[10px] text-text-tertiary tabular-nums">
          {yesMult}×
        </div>
      </div>

      {/* NO (pink) */}
      <div className={`relative overflow-hidden border border-no bg-no/10 ${padding}`}>
        <div
          className="absolute inset-y-0 right-0 bg-no/15 transition-[width] duration-500 ease-out"
          style={{ width: `${no}%` }}
        />
        <div className="relative flex items-baseline justify-between">
          <span className={`display tracking-[0.1em] text-no ${labelSize}`}>НЕТ</span>
          <span className={`display text-no ${numSize} leading-none`}>{no}%</span>
        </div>
        <div className="relative mt-1 font-mono text-[10px] text-text-tertiary tabular-nums">
          {noMult}×
        </div>
      </div>
    </div>
  );
}
